angular.module('unica_feedback_category.feedback_category_controllers')

.controller('FeedbackCategoryCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	FeedbackCategoryCreateService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$scope.pageTitle = 'Aggiungi Categoria';

	$rootScope.feedbackCategoryData = {
		event_id: $stateParams.event_id,
		title: '',
		description: ''
	};

	$scope.tinymceOptionsReady = false;
	$scope.tinymceOptionsEmailBody = angular.copy($rootScope.tinymceOptionsEmailBody);
	$scope.tinymceOptionsReady = true;

	$scope.saveFeedbackCategory = function() {
		$scope.showLoader();

		var feedbackCategoryData = angular.copy($rootScope.feedbackCategoryData);

		FeedbackCategoryCreateService
			.create(feedbackCategoryData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Categoria aggiunta con successo!', '');
					$state.go('app.feedback_category.list', { event_id: $stateParams.event_id });
				} else {
					$rootScope.manageError(data);
				}
			});
	};

})

;